<template>

  <div class="container">
    <img src="@/assets/Logo.svg" width="150" alt="">
    <h2>Redirigiendo a la tienda correcta...</h2>
    <p>Si no eres redirigido automáticamente, haz clic en uno de estos enlaces:</p>
  <div class="container-links">
    <a href="https://play.google.com/store/apps/details?id=com.colab.appcolab&pcampaignid=web_share">
      <img src="@/assets/android.svg" width="150" alt="">
    </a>
    <a href="https://apps.apple.com/hn/app/colab-app/id6741722848?l=en-GB">
      <img src="@/assets/apple.svg" width="150" alt="">
    </a>
  </div>


    <div class="container-footer">
      <img src="@/assets/finalcolab.png" width="250" alt="">
    </div>
  </div>

</template>
<script>
window.onload = function () {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  // URLs de tus apps
  const androidUrl = "https://play.google.com/store/apps/details?id=com.colab.appcolab&pcampaignid=web_share";
  const iosUrl = "https://apps.apple.com/hn/app/colab-app/id6741722848?l=en-GB";
  // const webUrl = "https://colab.hn/descargar"; // fallback opcional para escritorio

  if (/android/i.test(ua)) {
    window.location.href = androidUrl;
  } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    window.location.href = iosUrl;
  } else {
    // window.location.href = webUrl;
    return;
  }
};
</script>
<style lang="scss">
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;

  background-color: #191919;
  padding: 20px;
  gap: 20px;
}

.container h2 {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  font-family: 'Poppins', sans-serif;
  color: #fff;
  text-align: center;
}

.container p {
  font-size: 16px;
  margin-bottom: 20px;
  font-family: 'Poppins', sans-serif;
  color: #fff;
  text-align: center;
}

.container ul {
  list-style: none;
  padding: 0;
  margin: 0;
  font-family: 'Poppins', sans-serif;
  color: #fff;
}

.container ul li:before {
  content: "•";
  font-size: 24px;
  color: #000;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

.container ul li {
  font-size: 24px;
  list-style: none;
  margin-bottom: 10px;
}


.container ul li a {
  color: #000;
  text-decoration: none;
}


.container ul li a:hover {
  text-decoration: underline;
}

ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  list-style: none;
}
.container-links {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.container-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>
